import styled from '@emotion/styled';
import { tokens, Modal, Text } from '@hotjar/hotsauce';
import { ModalHeader } from './components/ModalHeader';

export const ModalStyles = {
  Modal: styled(Modal)`
    background: ${tokens.BRAND_COLORS.cobalt_100};
    margin: ${tokens.spacer.x6} auto;
    max-height: calc(100vh - ${tokens.spacer.x6} * 2);
    overflow: hidden;
    width: 1036px;
  `,
  ModalHeader: styled(ModalHeader)`
    background: ${tokens.color.white};
    border-bottom: 1px solid ${tokens.color.ui_border_light};
  `,
  ModalBody: styled(Modal.Body)`
    padding-top: ${tokens.spacer.x3};
  `,
  PriceLabel: styled(Text)`
    border-top: 1px solid ${tokens.color.ui_border};
    padding-top: ${tokens.spacer.x2};
  `,
  ModalFooter: styled(Modal.Footer)`
    background: ${tokens.color.white};
    align-items: center;
    border-top: 1px solid ${tokens.color.ui_border};
    padding: ${tokens.spacer.x2} ${tokens.spacer.x3} ${tokens.spacer.x3};
  `,
};

export const AskBarStyles = {
  Text: styled(Text)`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    max-width: 55%;
  `,
};
